import React, { useEffect, useState } from 'react'
import DisplayCard from '../../components/DisplayCard';
import { getAllCoursesIds } from '../../services/api/courses/getCourse';
import { useNavigate } from 'react-router-dom';
import { removeCourse } from '../../services/api/courses/removeCourse';
import FilledButton from '../../components/ui/FilledButton';

const Courses = () => {
    const [coursesList, setCoursesList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        getAllCoursesIds().then(response => {
            // console.log(response);
            if (response.error === null) {
                setCoursesList(response.data);
                setIsLoading(false);
            }
        })
    },[]);

    const navigate = useNavigate();

    const handleCourseEdit = (id) => {
        navigate(`/courses/edit/${id}`);
    }

    const handleCourseDelete = async (id) => {
        const isConfirmed = window.confirm('Are you sure u want to delete this course');
        if (isConfirmed) {
            const res = await removeCourse(id);
            if (res.error === null) {
                alert('Deleted challenge successfully');
            }else{
                alert('an error occurred');
            }
        }
    }

  return (
    <>
    <div className='flex justify-end items-center p-2'><FilledButton label={'create course'} onClick={() => navigate('/courses/create')} /></div>
    <div className='flex gap-4 items-center flex-wrap'>
        {
            isLoading?'Loading...':coursesList?.map((course,ind) => <DisplayCard key={ind} title={course?.title} handleDelete={() => handleCourseDelete(course?.course_id)} handleEdit={() => handleCourseEdit(course?.course_id)} />)
        }
    </div>
        </>
  )
}

export default Courses